<template>
  <div class="header-wrapper">
    <div class="left-wrapper fl">
      <div class="project-wrapper" @click="toModule">
        <img class="logo" src="@/assets/images/login/logo_white.png" alt="">
        <!-- <img class="logo" src="@/assets/images/login/logo1.png"> -->
        <h1 class="projectname">{{$t(`header.title`)}}</h1>
      </div>
    </div>
    <div class="right-wrapper fr">
      <div class="avatar-wrapper">
        <span class="help-language" @click="fathInfoV = !fathInfoV">{{$t(`manage.labelInfo`)}}</span>
        <el-badge value="new" class="item">
          <a class="help-language" :href="userinfo.role === 4 ? 'static/doc/manageHelp.pdf' : 'static/doc/vendorHelp.pdf'" target="_blank"  id="header-help">{{$t(`header.help`)}}</a>
        </el-badge>
        <v-language></v-language>
        <el-dropdown class="dropdown-wrapper" @command="handleCommand">
          <span :title="username" class="username-text">
            <span class="username text-overflow">{{username}}</span>
            <img class="pre" src="@/assets/images/head/select_nor.png" alt="">
            <img class="hot" src="@/assets/images/head/select_hot.png" alt="">
            <img class="avatar" src="@/assets/images/login/head_portrait.png" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="resetPassword">{{$t('header.resetPassword')}}</el-dropdown-item>
            <el-dropdown-item command="loginOut">{{$t('loginOut')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <v-reset :fatherDialogVisible="dialogVisible" @getResetPassword="getResetPassword"></v-reset>
    <v-label-info class="require-dialog" :fathInfoV="fathInfoV" @getInfoVisible="getInfoVisible"></v-label-info>
  </div>
</template>
<script>
import VLanguage from '@/components/User/Auth/Language.vue'
import VReset from '@/components/User/Auth/UpdatePassWord.vue'
import ZlgCloudHelper from '@/native/zlgcloudhelper.js'
import VLabelInfo from '@/components/User/Auth/LabelInfo.vue'
export default {
  components: {
    VReset,
    VLanguage,
    VLabelInfo
  },
  props: {
    navMenuModeIsHorizontal: {
      type: Boolean
    }
  },
  data () {
    return {
      userinfo: JSON.parse(localStorage.getItem('zlg_label_userinfo')),
      isCollapse: false,
      centerDialogVisible: true,
      dialogVisible: false,
      fathInfoV: false
    }
  },
  created () {
    this.fathInfoV = !localStorage.getItem('zlg_label_require')
    localStorage.setItem('zlg_label_require', true)
    this.username = this.userinfo.SupplierName ? this.userinfo.SupplierName : this.userinfo.username
  },
  methods: {
    getInfoVisible (val) {
      this.fathInfoV = val
    },
    toModule () {
      let rt = this.$route.path
      if (rt === "/Home/Label/CreatLabel") {
        this.$router.push(this.userinfo.role === 4 ? '/Home/Manage/ManageList' : '/Home/Order/OrderList')
      }
      if (rt === '/Home/Label/PrintLabel') {
        this.$router.push('/Home/Label/LabelList')
      }
    },
    menuSwitch () {
      this.isCollapse = !this.isCollapse
      this.$emit('menuSwitch')
    },
    handleCommand (command) {
      switch (command) {
        case 'userinfo':
          this.$router.push('/Home/User/RoleManager')
          break
        case 'resetPassword':
          this.dialogVisible = !this.dialogVisible
          break
        case 'loginOut':
          this.$router.push('/Login')
          localStorage.removeItem('zlg_label_userinfo')
          localStorage.removeItem('zlg_label_nav_active')
          sessionStorage.removeItem('needLoginAgain')
          break
        case 'setting':
          this.$emit('systemSetupDialog', this.centerDialogVisible)
          break
        default:
          break
      }
    },
    getResetPassword (val) {
      this.dialogVisible = val
    }
  }
}
</script>

<style lang="less" scoped>
.header-wrapper {
  height: 60px;
  line-height: 60px;
  background-color: #25374f;
  padding: 0 20px;
  min-width: 800px;
  .left-wrapper {
    .project-wrapper {
      position: relative;
      padding-left: 46px;
      .logo {
        position: absolute;
        top: 20px;
        left: 0;
        cursor: pointer;
      }
      .projectname {
        margin-left: 12px;
        font-size: 18px;
        color: #ffffff;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .nav-wrapper {
      // width: 100%;
      display: flex;
      align-items: center;
      .icon-switch {
        // margin-left: 10px;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  .right-wrapper {
    position: relative;
    padding-right: 40px;
    height: 60px;
    line-height: 60px;
    .avatar-wrapper {
      .help-language {
        color: #eaebed;
        display: inline-block;
        font-size: 14px;
        cursor: pointer;
      }
      .left-nav {
        font-size: 14px;
        color: #cce8ff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
        padding: 0 8px;
        margin: 0 14px;
      }
      .avatar {
        position: absolute;
        right: -38px;
        top: 16px;
        width: 30px;
        height: 30px;
        border-radius: 30px;
      }
      .dropdown-wrapper {
        margin-right: 30px;
        .username-text {
          .hot {
            display: none;
          }
          &:hover {
            .hot {
              display: inline-block;
            }
            .pre {
              display: none;
            }
          }
        }
        .username {
          // padding-bottom: 21px;
          // display: inline-block;
          color: #ffffff;
          cursor: pointer;
          // height: 22px;
          // line-height: 70px;
          max-width: 300px;
          margin-right: 6px;
        }
        .el-icon-arrow-down {
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// third_party/common_app/HomeModule/Container/ZWSHeader.vue